import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "content"];

  connect() {
    const hash = window.location.hash.replace(/^#/, "");
    const matched =
      hash &&
      this.tabTargets.find((tab) => tab.getAttribute("href") === `#${hash}`);
    this.showTab(matched ? matched.dataset.index : 0);
  }

  changeTab(event) {
    event.preventDefault();
    const tab = event.currentTarget;
    this.showTab(tab.dataset.index);
    const href = tab.getAttribute("href");
    if (href && href.startsWith("#")) {
      history.replaceState(null, "", href);
    }
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      const isActive = i == index;
      const isLine = tab.classList.contains("tab-item-line");
      tab.classList.toggle(
        isLine ? "tab-item-line-active" : "tab-item-active",
        isActive,
      );
      if (!isLine) tab.classList.toggle("text-gray-500", !isActive);
    });

    this.contentTargets.forEach((content) => {
      const isVisible = content.dataset.index == index;
      content.classList.toggle("hidden", !isVisible);
      if (isVisible) {
        content.classList.remove("tab-enter");
        void content.offsetWidth;
        content.classList.add("tab-enter");
      }
    });
  }
}
